import { ChangeDetectionStrategy, Component, Input, OnInit, effect, inject } from '@angular/core';
import { IBreadcrumb } from '../_shared/models/breadcrumb.model';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { ILink } from '../_shared/models/link.model';
import { BreadcrumbService } from '../_shared/services/breadcrumb.service';
import { BackgroundVariant } from '../_shared/models/hero/hero-variant.enum';

import { IconComponent } from '../icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { LinkDirective } from '../_shared/directives/link.directive';
import { ContainerComponent } from '../container/container.component';

@Component({
    selector: 'sirius-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ContainerComponent, LinkDirective, IconComponent, TranslateModule],
    host: {
        'class': 'sir-text-style-paragraph-s-default',
        'data-cy': 'breadcrumb',
        // A light variant sets nothing, so the breadcrumb inherits its section's surface.
        '[class.is-dark]': 'hasDarkBackground',
        // Deprecated aliases, kept for one release.
        '[class.has-dark-background]': 'hasDarkBackground',
        '[class.has-light-background]': 'hasLightBackground',
    }
})
export class BreadcrumbComponent implements IDynamicElement, OnInit {
    private readonly _breadcrumbService = inject(BreadcrumbService);

    @Input() items: ILink[] = [];
    @Input() variant?: BackgroundVariant;

    config?: IBreadcrumb;

    get parentPageLink(): ILink | undefined {
        return this.items.length >= 2 ? this.items[this.items.length - 2] : undefined;
    }

    get computedVariant(): BackgroundVariant {
        return this.variant ?? this._breadcrumbService.variant();
    }

    get hasDarkBackground(): boolean {
        return this.computedVariant === BackgroundVariant.DARK;
    }

    get hasLightBackground(): boolean {
        return this.computedVariant === BackgroundVariant.LIGHT;
    }

    constructor() {
        effect(() => {
            this._breadcrumbService.variant();
        });
    }

    ngOnInit(): void {
        if (this.config) {
            this.items = this.config.items;
            this.variant = this.config.variant;
        }
    }
}
